export const monthsOfYear = [6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5];

export const monthsWithPeriods = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3];

export const monthsOfYearsHave14Months = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5];

export const monthsOfYearsHave13Months = [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4];

export const monthsOfYearsHave12Months = [6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5];

export const monthsOfYearsHave10Months = [6, 7, 8, 9, 10, 11, 12, 1, 2, 3];
